<template>
    <div class="loading-box">
        <div class="loading-list">
            <div class="loading-item mb-1rem" v-for="l in 4">
                <div class="display-flex-align-center mb-1rem">
                    <div class="circle animation mr-05rem"></div>
                    <div class="pill animation"></div>
                </div>
        
                <div class="rect animation mb-1rem"></div>
        
                <div>
                    <div class="pill animation pill-text mb-0525px w-70"></div>
                    <div class="pill animation pill-text mb-1rem w-100"></div>
                </div>
        
                <div class="display-flex-align-center">
                    <div class="pill animation pill-tag mr-1rem"></div>
                    <div class="pill-column animation mr-5px"></div>
                    <div class="pill animation pill-tag"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading2'
    }
</script>


<style scoped src="../../assets/css/loading/index.css"></style>